<div class="paging">
  <ul>
    <li class="prev" (click)="onClickPage(activePage - 1)">
      <span></span>
    </li>
    <li [ngClass]="{ current: page === activePage }" *ngFor="let page of pages" (click)="onClickPage(page)">
      <span>{{ page }}</span>
    </li>
    <li class="next" (click)="onClickPage(activePage + 1)">
      <a>
        <span></span>
      </a>
    </li>
  </ul>
</div>
